module.exports = __webpack_public_path__ + "static/media/intro.d0a0b488.png";